var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _a, _ClientStorage_storageRegistry, _ClientStorage_registryKey, _ClientStorage_getStrategyByBrowserSupport, _ClientStorage_persistRegistry, _ClientStorage_loadRegistry, _ClientStorage_getRegistryData;
import IndexedDBStrategy from './strategies/IndexedDBStrategy';
import LocalStorageStrategy from './strategies/LocalStorageStrategy';
import { StorageStrategyErrors } from './StorageErrors';
import { setCookieValue, getCookieValue } from '../cookies/cookie';
import MemoryStorageStrategy from './strategies/MemoryStorageStrategy';
const storageStrategies = {
    indexedDB: IndexedDBStrategy,
    localStorage: LocalStorageStrategy,
    memory: MemoryStorageStrategy
};
class ClientStorage {
    static init() {
        __classPrivateFieldGet(_a, _a, "m", _ClientStorage_loadRegistry).call(_a);
    }
    static async retrieveStorage(dbName, strategy) {
        const existingStorage = this.getStorage(dbName);
        if (existingStorage) {
            return existingStorage;
        }
        return this.createStorage(dbName, strategy);
    }
    static getStorage(dbName) {
        const storageInstance = __classPrivateFieldGet(_a, _a, "f", _ClientStorage_storageRegistry)[dbName];
        return storageInstance?.instance ?? null;
    }
    static async createStorage(dbName, strategy) {
        const existingStorage = this.getStorage(dbName);
        if (existingStorage) {
            throw new Error(StorageStrategyErrors.STORAGE_EXISTS);
        }
        const Strategy = strategy ?? __classPrivateFieldGet(_a, _a, "m", _ClientStorage_getStrategyByBrowserSupport).call(_a);
        const instance = new Strategy(dbName);
        await instance.initialize();
        __classPrivateFieldGet(_a, _a, "f", _ClientStorage_storageRegistry)[dbName] = { strategy: Strategy, instance };
        __classPrivateFieldGet(_a, _a, "m", _ClientStorage_persistRegistry).call(_a);
        return instance;
    }
}
_a = ClientStorage, _ClientStorage_getStrategyByBrowserSupport = function _ClientStorage_getStrategyByBrowserSupport() {
    if ('indexedDB' in window && window.indexedDB) {
        return storageStrategies.indexedDB;
    }
    if ('localStorage' in window && window.localStorage) {
        return storageStrategies.localStorage;
    }
    return storageStrategies.memory;
}, _ClientStorage_persistRegistry = function _ClientStorage_persistRegistry() {
    const value = JSON.stringify(__classPrivateFieldGet(_a, _a, "f", _ClientStorage_storageRegistry));
    if ('localStorage' in window && window.localStorage) {
        localStorage.setItem(__classPrivateFieldGet(_a, _a, "f", _ClientStorage_registryKey), JSON.stringify(__classPrivateFieldGet(_a, _a, "f", _ClientStorage_storageRegistry)));
        return;
    }
    setCookieValue(__classPrivateFieldGet(_a, _a, "f", _ClientStorage_registryKey), value);
}, _ClientStorage_loadRegistry = function _ClientStorage_loadRegistry() {
    const registryData = __classPrivateFieldGet(_a, _a, "m", _ClientStorage_getRegistryData).call(_a);
    if (registryData) {
        __classPrivateFieldSet(_a, _a, JSON.parse(registryData), "f", _ClientStorage_storageRegistry);
    }
}, _ClientStorage_getRegistryData = function _ClientStorage_getRegistryData() {
    if ('localStorage' in window && window.localStorage) {
        return localStorage.getItem(__classPrivateFieldGet(_a, _a, "f", _ClientStorage_registryKey));
    }
    return getCookieValue(__classPrivateFieldGet(_a, _a, "f", _ClientStorage_registryKey));
};
_ClientStorage_storageRegistry = { value: {} };
_ClientStorage_registryKey = { value: 'storageRegistry' };
export default ClientStorage;
